import { render, staticRenderFns } from "./ProductQuotation.vue?vue&type=template&id=61bc2e04&scoped=true"
import script from "./ProductQuotation.vue?vue&type=script&lang=js"
export * from "./ProductQuotation.vue?vue&type=script&lang=js"
import style0 from "./ProductQuotation.vue?vue&type=style&index=0&id=61bc2e04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61bc2e04",
  null
  
)

export default component.exports